"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _weixinJsSdk = _interopRequireDefault(require("weixin-js-sdk"));

var _axios = _interopRequireDefault(require("axios"));

var _DOMAINSMAP = _interopRequireDefault(require("./DOMAINSMAP"));

/**
 * @name: share ;
 * @author: sophiehui ;
 * @description: wx-share for qingting ;
 * */
var ua = navigator.userAgent.toLowerCase();
var isInWeixin = /micromessenger/.test(ua);

function init() {
  var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'prd';
  var configUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (isInWeixin) {
    // 生产环境host才有效
    var url = window.location.href.split('#')[0];
    var current_domain = window.location.hostname;
    var currentConfigUrl = (0, _DOMAINSMAP["default"])(current_domain);

    if (configUrl) {
      currentConfigUrl = configUrl;
    }

    if (!currentConfigUrl) return;
    var params = {};

    if (!configUrl) {
      params = {
        url: url
      };
    }

    _axios["default"].get(currentConfigUrl, {
      params: params
    }).then(function (res) {
      var data = res.data;

      _weixinJsSdk["default"].config({
        //debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId,
        // 必填，公众号的唯一标识
        timestamp: data.timestamp,
        // 必填，生成签名的时间戳
        nonceStr: data.nonceStr,
        // 必填，生成签名的随机串
        signature: data.signature,
        // 必填，签名，见附录1
        jsApiList: ['checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2

      });
    });
  }
}

var self = {
  isInWeixin: isInWeixin,

  /**
   * 同时设置分享给朋友和朋友圈
   * @param {object} config {title, link, desc, imgUrl, type, dataUrl, success, cancel}
   */
  setShareConfig: function setShareConfig(config) {
    self.setShareFriendConfig(config);
    self.setShareTimelineConfig(config);
  },
  initShare: function initShare(env, configUrl) {
    init(env, configUrl);
  },

  /**
   * 分享给朋友
   * @param {object} config
   */
  setShareFriendConfig: function setShareFriendConfig(config) {
    _weixinJsSdk["default"].ready(function () {
      _weixinJsSdk["default"].onMenuShareAppMessage(config);
    });
  },

  /**
   * 分享到朋友圈
   * @param {object} config
   */
  setShareTimelineConfig: function setShareTimelineConfig(config) {
    _weixinJsSdk["default"].ready(function () {
      _weixinJsSdk["default"].onMenuShareTimeline(config);
    });
  },
  hiddenShareItems: function hiddenShareItems() {
    _weixinJsSdk["default"].ready(function () {
      _weixinJsSdk["default"].hideOptionMenu();
    });
  }
};
var _default = self;
exports["default"] = _default;